import { Field, Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import { genOptionLoaderParams } from "../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../_redux/organization/organizationCrud";
import AsyncSelect from "react-select/async";
import { NOTIFICATION_ORGANIZATION_TYPES_ARRAY } from "../NotificationUIHelpers";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { utc_minutes_offset } from "../../../../../../_metronic/_helpers/time-helpers";
import { findAllOrgRegional } from "../../../_redux/organization-regional/organizationRegionalCrud";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama folder tidak boleh kosong!")
});

export default function NotificationCreateForm({ onSubmit, defaultValues }) {
  const categoryNotification = [
    { name: "Semua Organisasi", value: true },
    { name: "Pilih Organisasi", value: false }
  ];

  const [currentTimeout, setCurrentTimeout] = useState(null);
  const [regionalList, setRegionalList] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [idOrganization, setIdOrganization] = useState('');

  const fetchOrgRegional = async () => {
    try {
      const result = await findAllOrgRegional();

      if (!result) {
        return setRegionalList([]);;
      }

      let dataOptions = result.data.data.map(item => {
        return {
          value: item.uuid,
          label: item.name
        };
      });

      setRegionalList(dataOptions);

    } catch (err) {
      setRegionalList([]);
    }
  };

  const fetchOrganizations = async (region) => {
    try {
      const result = await findorganization({
        page1umber: 1,
        pageSize: 50,
        filter: { organization_regional_uuid: region }
      });

      if (!result) {
        return setOrganizations([]);
      }

      let dataOptions = result.data.data.items.map(item => {
        return {
          value: item.uuid,
          label: item.name
        };
      });


      setOrganizations(dataOptions);

    } catch (err) {
      setOrganizations([]);
    }
  }

  useEffect(() => {
    fetchOrgRegional();

    fetchOrganizations(idOrganization)
  }, [idOrganization]);

  return (
    <Formik
      initialValues={{
        ...defaultValues,
        expired_date: moment(defaultValues.expired_date)
          .utc(0)
          .add(-utc_minutes_offset, "minute")
          .format("YYYY-MM-DD HH:mm:ss")
      }}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          {!values.uuid && (
            <div className="form-group row">
              <div className="col-lg-3">
                <label>
                  <strong>Kategori</strong>
                </label>
                <select
                  className="form-control"
                  name="is_all_organization"
                  value={values.is_all_organization}
                  onChange={e => {
                    setFieldValue("organization_uuids", []);
                    setFieldValue(
                      "is_all_organization",
                      !values.is_all_organization
                    );
                  }}
                >
                  {categoryNotification.map(row => (
                    <option key={row.name} value={row.value}>
                      {row.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-3" hidden={defaultValues.uuid}>
                {!values.is_all_organization && (
                  <>
                    <label>
                      <strong>Regional</strong>
                    </label>
                    <Select 
                      name="region"
                      onChange={(e) => {
                        setFieldValue("region", e.target?.value);
                        setIdOrganization(e.target.value);
                      }}
                    >
                      <option key='' value=''>Semua Regional</option>
                      {regionalList.map(row => (
                        <option key={row.label} value={row.value}>
                          {row.label}
                        </option>
                      ))}
                    </Select>
                  </>
                )}
              
            </div>
              <div className="col-lg-6">
                {!values.is_all_organization && (
                  <>
                    <label>
                      <strong>Pilih Organisasi</strong>
                    </label>
                    <AsyncSelect
                      name="organization_uuid"
                      isMulti
                      defaultOptions={organizations}
                      loadOptions={genOptionLoaderParams(
                        inputValue =>
                          findorganization({
                            page1umber: 1,
                            pageSize: 50,
                            filter: { name: inputValue, organization_regional_uuid: values.region }
                          }),
                        ({ name, uuid }) => ({
                          label: name,
                          value: uuid
                        }),
                        currentTimeout,
                        setCurrentTimeout
                      )}
                      value={
                        values.organization_uuids instanceof Array
                          ? values.organization_uuids
                          : []
                      }
                      onChange={values => {
                        if (values instanceof Array) {
                          return setFieldValue("organization_uuids", values);
                        }
                        setFieldValue("organization_uuids", []);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )}
          <div className="form-group row">
            <div className="col-lg-6">
              <label>
                <strong>Tipe</strong>
              </label>
              <Select name="type">
                {NOTIFICATION_ORGANIZATION_TYPES_ARRAY.map(row => (
                  <option key={row.name} value={row.value}>
                    {row.name}
                  </option>
                ))}
              </Select>
            </div>
            <div className="col-lg-6">
              <Field
                name="expired_date"
                label="Expired Date"
                component={Input}
                value={values.expired_date}
                type="datetime-local"
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <label>
                <strong>Message</strong>
              </label>
              <textarea
                name="message"
                placeholder="Message..."
                className="form-control"
                value={values.message}
                onChange={e => setFieldValue("message", e.target.value)}
              />
            </div>
          </div>
          <button
            className="btn btn-primary float-right"
            onClick={handleSubmit}
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
